export default __webpack_public_path__ + "static/media/Branded-red.73545515.png";